import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { IDataSource } from '@se/cp.common';
import { SeAutocompleteModule } from '@se/platform';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-autocomplete-cell-editor-popup',
    templateUrl: './autocomplete-cell-editor-popup.component.html',
    styleUrls: ['./autocomplete-cell-editor-popup.component.scss'],
    imports: [FocusSelectOnDirective, MatCardModule, SeAutocompleteModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteCellEditorPopupComponent {
    readonly autocompleteFormControl = input.required<FormControl>();
    readonly cellReady = input.required<boolean>();
    readonly items = input.required<string[] | IDataSource>();

    updateValue(newValue: string): void {
        const formControl = this.autocompleteFormControl();
        formControl.setValue(newValue);
    }

    optionClicked(value: string) {
        this.updateValue(value);
    }

    getValue(): string {
        const formControl = this.autocompleteFormControl();
        return formControl.getRawValue();
    }

    isRequired(): boolean {
        const formControl = this.autocompleteFormControl();
        return formControl.hasValidator(Validators.required);
    }
}
